import { ITakeOffToEnRouteInitialState } from "./types";

const initialState: ITakeOffToEnRouteInitialState = {
  isManualControl: false,
};

export default initialState;